<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Terms Of Service" />
            <TermsOfService />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'
import TermsOfService from '../TermsOfService/TermsOfService'
import FooterComp from '../Layouts/FooterComp'

export default {
    name: 'TermsOfServicePage',
    components: {
        NavBar,
        PageTitle,
        TermsOfService,
        FooterComp,
    }
}
</script>